import { motion } from 'framer-motion';
import { DOCTORS } from './data';
// TEAM — clinical bio cards
export default function Team({ setPage }) {
  return (
    <div className="bg-[#F8FAFB] text-[#0A2E3C]">
      <section className="pt-12 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#1B7A8C]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B7A8C] mb-3">⊕ Section III / Doctors</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92]">Three dentists, <span className="italic text-[#1B7A8C]">named on every record</span>.</h1>
      </section>
      <section className="max-w-[1500px] mx-auto px-8 lg:px-14 py-16 grid md:grid-cols-3 gap-px bg-[#1B7A8C]/15">
        {DOCTORS.map((d, i) => (
          <motion.div key={d.name} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="bg-white p-8">
            <div className="aspect-[4/5] overflow-hidden mb-5"><img src={d.img} alt={d.name} className="w-full h-full object-cover" loading="lazy" /></div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#E08672]">/ Doctor 0{i + 1}</p>
            <h2 className="font-serif text-3xl mt-1">{d.name}</h2>
            <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#1B7A8C] mt-2">{d.title}</p>
            <table className="font-mono text-[11px] mt-5 w-full">
              <tbody>
                <tr className="border-b border-[#1B7A8C]/10"><td className="py-2 text-[#0A2E3C]/45 tracking-[0.18em] uppercase w-24">Special</td><td className="py-2" dangerouslySetInnerHTML={{ __html: d.spec }} /></tr>
                <tr className="border-b border-[#1B7A8C]/10"><td className="py-2 text-[#0A2E3C]/45 tracking-[0.18em] uppercase">Edu</td><td className="py-2" dangerouslySetInnerHTML={{ __html: d.edu }} /></tr>
              </tbody>
            </table>
            <button onClick={() => setPage('book')} className="mt-5 w-full bg-[#1B7A8C] text-white py-3 font-mono text-[10px] tracking-[0.3em] uppercase hover:bg-[#E08672] transition-colors">Book with {d.name.split(' ')[1]} →</button>
          </motion.div>
        ))}
      </section>
    </div>
  );
}
